module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("Prologue: “So Much Was All Compressed”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("New Year’s Day")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("January")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  3. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("  9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December")])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: “A New Birth of Freedom”")])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Also by Daid Von Drehle")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0